export default class NewsSingle{

    constructor(){
        this._init();
    }

    _init(){
        this._setShare();
    }

    _setShare(){
        const url = encodeURIComponent(location.href);
        const text = encodeURIComponent(document.title);
        const hashtag = encodeURIComponent('気になってる人が男じゃなかった');

        const twitterlink = document.querySelector(".js-share-x a");
        if (twitterlink) {
            twitterlink.setAttribute(
                "href",
                `//x.com/intent/tweet?text=${text}&url=${url}&hashtags=${hashtag}`
            );
        }
    }
}